import { ICellRendererParams } from "ag-grid-community";
import { ShieldAlert } from "lucide-react";
import React from "react";

import { IgTooltip } from "@intelligems/ig-theme";
import { AgencyDto } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";

export const StatusColumn = (params: ICellRendererParams<AgencyDto>) => {
  const theme = useTheme();
  if (!params.data || (params.data && params.data.billing)) {
    return null;
  }

  return (
    <Grid
      container
      columnSpacing={2}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Grid item sx={{ marginTop: "5px" }}>
        <IgTooltip title={"Payment Method Missing"}>
          <ShieldAlert color={theme.igIconColors.error} />
        </IgTooltip>
      </Grid>
    </Grid>
  );
};
